import { Suspense } from "react";
import { useTranslation } from "react-i18next";

/**
 * Preload translations. Useful for preloading the translations for upcoming pages.
 * @param param0
 * @returns
 */
export default function LoadTranslation({ keys }: { keys: string[] }) {
  return (
    <Suspense fallback={null}>
      <TranslationComp keys={keys} />
    </Suspense>
  );
}

function TranslationComp({ keys }: { keys: string[] }) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useTranslation(keys);
  return null;
}
